import React from "react"
import NumberFormat from "react-number-format";

export const validation = (e, columns, callback) => {
    if (typeof e === 'object') {
        
        for (const i in e) {
            columns.forEach((formValue) => {
                if (formValue.name === i) {
                    formValue.error = e[i];
                }
            })

            callback(columns);
        }
    }
}

export const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, max=100, ...other } = props;
    const MAX_VAL = max;
    const withValueLimit = ({ floatValue }) => floatValue <= MAX_VAL;

    return (
        <NumberFormat
            {...other}
            getInputRef={ref}
            isAllowed={withValueLimit}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            suffix={'%'}
        />
    );
});
